import { FC } from "react";
import { Box, Button, DialogActions, Modal, Typography } from "@mui/material";
import theme from "@/theme";

interface IDeleteModalProps {
  open: boolean;
  handleClose: () => void;
  onDelete: () => void;
  time: string;
}

const CancelSubscriptionModal: FC<IDeleteModalProps> = ({ open, handleClose, onDelete, time }) => {
  const onConfirm = () => {
    handleClose();
    onDelete();
  };

  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: "400px",
          height: "auto",
          bgcolor: theme.palette.custom.mainWhite,
          boxShadow: "0 32px 48px -8px rgba(0, 0, 0, 0.1), 0 0 14px -4px rgba(0, 0, 0, 0.05)",
          padding: "16px",
          borderRadius: "1.5rem",
          outline: "none",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Box sx={{ display: "flex", flexDirection: "column", gap: "14px" }}>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "4px", alignItems: "center" }}>
            <Typography
              sx={{
                fontSize: "16px",
                lineHeight: "22px",
                letterSpacing: 0,
                color: "#1A1D1F",
                fontWeight: 500,
                textAlign: "center",
              }}
            >
              Are you sure you'd like to cancel your subscription?
            </Typography>
            <Typography
              sx={{
                fontSize: "14px",
                lineHeight: "22px",
                letterSpacing: 0,
                color: "#6F767E",
                fontWeight: 500,
              }}
            >
              Here's what you need to know:
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  lineHeight: "22px",
                  color: "#6F767E",
                  fontWeight: 500,
                }}
              >
                •
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  lineHeight: "22px",
                  letterSpacing: 0,
                  color: "#6F767E",
                  fontWeight: 500,
                }}
              >
                We will not bill you again for your Wethermarket subscription.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "row", gap: "8px" }}>
              <Typography
                sx={{
                  fontSize: "14px",
                  lineHeight: "22px",
                  color: "#6F767E",
                  fontWeight: 500,
                }}
              >
                •
              </Typography>
              <Typography
                sx={{
                  fontSize: "14px",
                  lineHeight: "22px",
                  letterSpacing: 0,
                  color: "#6F767E",
                  fontWeight: 500,
                }}
              >
                Your current subscription will continue until it expires at the end of the current
                billing period ({time})
              </Typography>
            </Box>
          </Box>
        </Box>
        <DialogActions
          sx={{
            justifyContent: "center",
            mt: "14px",
            padding: "0",
            width: "100%",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", width: "100%", marginBlock: "12px" }}>
            <Button
              onClick={handleClose}
              sx={{
                width: "50%",
                flex: 1,
                fontSize: "16px",
                lineHeight: "22px",
                letterSpacing: 0,
                color: "#2A85FF",
                fontWeight: 500,
                padding: 0,
                textTransform: "none",
              }}
            >
              Take me back
            </Button>
            <Button
              onClick={onConfirm}
              sx={{
                flex: 1,
                width: "50%",
                fontSize: "16px",
                lineHeight: "22px",
                letterSpacing: 0,
                color: "#CE212B",
                fontWeight: 500,
                padding: 0,
                textTransform: "none",
              }}
            >
              Continue cancellation
            </Button>
          </Box>
        </DialogActions>
      </Box>
    </Modal>
  );
};

export default CancelSubscriptionModal;
